module.exports = __webpack_public_path__ + "static/formmodifier-button-dont-967ce55e257c5a4b61f9ead3d5dc9442.png";